(() => {
  if (window.MCFaq) return

  const normalize = (value = '') => {
    return String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
  }

  const init = (root) => {
    if (root.dataset.mcFaqReady === 'true') return

    const form = root.querySelector('[data-mc-faq-search-form]')
    const search = root.querySelector('[data-mc-faq-search]')
    const results = root.querySelector('[data-mc-faq-results]')
    const items = Array.from(root.querySelectorAll('[data-mc-faq-item]'))
    const empty = root.querySelector('[data-mc-faq-empty]')
    const quickButtons = Array.from(root.querySelectorAll('[data-mc-faq-query]'))

    if (!search || !items.length) return

    const scrollToResults = () => {
      if (!results) return

      window.requestAnimationFrame(() => {
        results.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }

    const filter = ({ scroll = false } = {}) => {
      const query = normalize(search.value)
      let visibleItems = 0

      items.forEach((item) => {
        const isVisible = !query || normalize(item.dataset.search || '').includes(query)
        item.hidden = !isVisible
        if (isVisible) visibleItems += 1
      })

      if (empty) empty.hidden = visibleItems > 0

      quickButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(normalize(button.dataset.mcFaqQuery) === query && query !== ''))
      })

      if (scroll && query) scrollToResults()
    }

    search.addEventListener('input', () => {
      filter()
    })

    search.addEventListener('blur', () => {
      if (normalize(search.value)) filter({ scroll: true })
    })

    form?.addEventListener('submit', (event) => {
      event.preventDefault()
      filter({ scroll: true })
    })

    quickButtons.forEach((button) => {
      button.addEventListener('click', () => {
        search.value = button.dataset.mcFaqQuery || ''
        filter({ scroll: true })
        search.focus({ preventScroll: true })
      })
    })

    filter()
    root.dataset.mcFaqReady = 'true'
  }

  const initAll = (container = document) => {
    if (container.matches?.('[data-mc-faq]')) init(container)
    container.querySelectorAll?.('[data-mc-faq]').forEach(init)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true })
  } else {
    initAll()
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target))
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('[data-mc-faq-item]')
    const collapse = item?.querySelector('.accordion-collapse')

    if (!item || !collapse || !window.bootstrap) return

    item.hidden = false
    window.bootstrap.Collapse.getOrCreateInstance(collapse, { toggle: false }).show()
  })

  window.MCFaq = { init: initAll }
})()
